<div class="card" [style.border-color]="color" (click)="activeCard()">
  <div class="card-body">
    <div class="icon" [style.color]="color">
      <i [class]="iconClass"></i>
    </div>
    <div class="value">
      <div class="value-content">
        <div class="number">{{value}}</div>
      </div>
      <div class="description">{{ description | translate }}</div>
    </div>
  </div>
</div>
